// extracted by mini-css-extract-plugin
module.exports = {"SButton":"WatchlistActionButton_SButton__8sum6","SWatchlistSvg":"WatchlistActionButton_SWatchlistSvg__MJMva","SWatchListLabel":"WatchlistActionButton_SWatchListLabel__L2F7L"};